import React from 'react';
import classNames from 'classnames';
import './index.scss';

export default config => WrappedComponents => (props) => {
    let style = classNames(`page page-${config.name}`);

    return (
        <div className={style}>
            <div className="page-bd">
                <WrappedComponents {...props} updateHeaderStyle={props.updateHeaderStyle} />
            </div>

            <a className="copy-right" href="https://beian.miit.gov.cn/" target="_blank">
                {/*<span className="bd">© 2022 沪ICP备 2024066019号-1</span>*/}
                <span className="bd">© 2025 沪公网安备 31010102008012号</span>
            </a>
        </div>
    );
};
